import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/AccountsAPI/verifyUnsLoanInterestAPI';

const err = (e, fallback) => e?.ErrorDetails?.ErrorMessage || e?.Message || e?.message || fallback;

export const fetchUnsLoanInterestQueue = createAsyncThunk(
    'verifyUnsLoanInterest/fetchQueue',
    async (roleId, { rejectWithValue }) => {
        try { return await api.getVerificationUnsLoanInterest(roleId); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch loan interest verification queue')); }
    }
);

export const submitApproveUnsLoanInterest = createAsyncThunk(
    'verifyUnsLoanInterest/approve',
    async (payload, { rejectWithValue }) => {
        try { return await api.approveUnsLoanInterest(payload); }
        catch (e) { return rejectWithValue(err(e, 'Error Occurred')); }
    }
);

const initialState = {
    queue: [], queueLoading: false, queueError: null,
    verifyLoading: false,
};

const verifyUnsLoanInterestSlice = createSlice({
    name: 'verifyUnsLoanInterest',
    initialState,
    reducers: {
        resetVerifyUnsLoanInterest: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUnsLoanInterestQueue.pending, (s) => { s.queueLoading = true; s.queueError = null; })
            .addCase(fetchUnsLoanInterestQueue.fulfilled, (s, a) => { s.queueLoading = false; s.queue = a.payload?.Data || []; })
            .addCase(fetchUnsLoanInterestQueue.rejected, (s, a) => { s.queueLoading = false; s.queueError = a.payload; s.queue = []; });

        builder
            .addCase(submitApproveUnsLoanInterest.pending, (s) => { s.verifyLoading = true; })
            .addCase(submitApproveUnsLoanInterest.fulfilled, (s) => { s.verifyLoading = false; })
            .addCase(submitApproveUnsLoanInterest.rejected, (s) => { s.verifyLoading = false; });
    },
});

export const { resetVerifyUnsLoanInterest } = verifyUnsLoanInterestSlice.actions;

export const selectVUIQueue = (s) => s.verifyUnsLoanInterest.queue;
export const selectVUIQueueLoading = (s) => s.verifyUnsLoanInterest.queueLoading;
export const selectVUIQueueError = (s) => s.verifyUnsLoanInterest.queueError;
export const selectVUIVerifyLoading = (s) => s.verifyUnsLoanInterest.verifyLoading;

export default verifyUnsLoanInterestSlice.reducer;
